module.exports = __webpack_public_path__ + "static/media/rd6.5fd667f8.png";